module.exports = __webpack_public_path__ + "static/media/kRAcuvue2.cd33e7fc.png";